/**
 * Enum Tính thuế
 * TVDAT 12.07.2022
 */
export default {
  All: -1,
  IsPersonalIncomeTax: 1,
  NotIsPersonalIncomeTax: 0,
};
